import type { ProductInfoProduct } from '../../types'
import {
  getMainImageUrl,
  type MasterVariantImageFields,
} from '../getMainImageUrl'

type ProductImageSource = {
  dynamicImages?: ProductInfoProduct['dynamicImages']
  masterVariant: MasterVariantImageFields
}

export const getProductDisplayImageUrl = (
  product: ProductImageSource,
  isDynamicImagesEnabled: boolean,
): string | undefined => {
  const dynamicImageUrl =
    isDynamicImagesEnabled && product.dynamicImages?.medium?.webp?.[0]?.url

  if (dynamicImageUrl) {
    return dynamicImageUrl
  }

  const mainImageUrl = getMainImageUrl(product.masterVariant)

  return mainImageUrl || undefined
}

export const hasProductDisplayImage = (
  product: ProductImageSource,
  isDynamicImagesEnabled: boolean,
): boolean =>
  Boolean(getProductDisplayImageUrl(product, isDynamicImagesEnabled))
